export default "__VITE_ASSET__Bx0bTFiv__"